import { Personas } from '@/enums/persona';
import {
  Component, Vue, ProvideReactive,
} from 'vue-property-decorator';
import HttpService from '../../../services/httpService';
import { Inject } from 'vue-di-container';
import UserService from '../../../services/userService';
import WithRender from './persona-container.html';

@WithRender
@Component
export default class PersonaContainer extends Vue {
@Inject(HttpService)
public httpService!: HttpService;

@Inject(UserService)
public userService!: UserService;

@ProvideReactive()
public persona:Personas = Personas.ANONYMOUS;

async created() {
  const res = await this.userService.getUser();
  this.persona = res.loginType;
}
}
